const FILTERS = {
  "sdsb-hspc": {
    hspc_version: {
      title: "HSPC Version",
      icon: "os_kernel.png",
    },
    supported_os: {
      title: "Supported OS",
      icon: "os.png",
    },
    container_orchestrator: {
      title: "Container Orchestrator",
      icon: "os.png",
    },

    orchestrator_version: {
      title: "Orchestrator Version",
      icon: "os.png",
    },
    hvssb_software_version: {
      title: "Software Version",
      icon: "array.png",
    },
    array: {
      title: "Array",
      icon: "array.png",
    },
    protocol: {
      title: "Protocol",
      iconClass: "network-wired",
    },
    csi_version: {
      title: "CSI Version",
      icon: "array_if.png",
    },
  },
};
export default FILTERS;
